import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateRangeComponent } from "../date-range/date-range.component";
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';

@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, DateRangeComponent, NzCollapseModule, NzBadgeModule, NzDatePickerModule, NzDropDownModule],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent {
  totalFilters: number = 0
  @Input() data: Array<any> = [];
  @Output() filterChanged: EventEmitter<any> = new EventEmitter<any>()
  @Output() clearFilter: EventEmitter<any> = new EventEmitter()
  constructor() {
  }
  ngOnInit(): void {
  }
  ngOnChanges(changes: any) {
    if (changes.data.currentValue !== undefined) {
      changes.data.currentValue.forEach((el: any) => {
        // console.log(el)
        if (el.type === 'date-range') {
          if (el.fromDate !== null && el.toDate !== null) {
            el.fromDateValue = el.fromDate;
            el.toDateValue = el.toDate;
            this.totalFilters++;
            el.isApplied = true;
          }
        } else {
          if (el.defaultValue !== '' && el.defaultValue !== null) {
            el.value = el.defaultValue;
            this.totalFilters++;
            el.isApplied = true;
          }
        }
      })
    }
  }
  onChange(event: any, input: any, where = '') {
    let value = ''
    if (where == 'date') {
      value = event
    } else {
      value = event.target.value
    }
    if (value == '') {
      this.totalFilters--;
      input.isApplied = false;
    } else {
      if (!input?.isApplied) {
        input.isApplied = true;
        this.totalFilters++;
      }
    }
  }
  clear() {
    this.data.forEach((el: any) => {
      if (el.type == 'date-range') {
        el.fromDateValue = ''
        el.toDateValue = ''
      } else {
        el.value = ''
      }
      el.isApplied = false
    })
    this.totalFilters = 0
    this.clearFilter.emit()
  }
  onApplyFiter() {
    // console.log(this.data)
    this.filterChanged.emit(this.data)
  }
}
